import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgHeadsetOwl: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg viewBox="0 0 275 231" {...props}>
    <g fill="none" fillRule="nonzero">
      <path
        d="M55.9 83.17l14.15-40.52 20.88 10.11c13.94-7.12 29.89-11.05 46.79-10.74 18.05.32 34.88 5.46 49.2 14.1l21.2-8.42 10.72 39.7c9.25 14.8 14.47 32.25 14.15 50.85-.96 52.2-45.15 93.72-98.72 92.73-53.54-.95-96.22-44.03-95.25-96.22.33-19.19 6.54-36.88 16.88-51.59"
        fill="#FF7300"
      />
      <path
        d="M111 138.77s24.48-8.48 55 0c0 0-8.94 17.67-28.29 30.23 0 0-18.22-11.82-26.71-30.23"
        fill="#FFFFFE"
      />
      <path
        d="M124 124.5c0 15.74-12.76 28.5-28.5 28.5S67 140.24 67 124.5 79.76 96 95.5 96s28.5 12.76 28.5 28.5M210 124.5c0 15.74-12.76 28.5-28.5 28.5S153 140.24 153 124.5 165.76 96 181.5 96s28.5 12.76 28.5 28.5"
        fill="#FFFFFE"
      />
      <path
        d="M181 116.34a8.54 8.54 0 0 0 8.37 8.66 8.52 8.52 0 0 0 8.63-8.37c.1-4.68-3.66-8.56-8.34-8.63a8.53 8.53 0 0 0-8.66 8.34M96 117.37a8.47 8.47 0 0 0 8.35 8.63c4.7.1 8.57-3.65 8.65-8.35a8.5 8.5 0 0 0-8.35-8.65 8.51 8.51 0 0 0-8.65 8.37"
        fill="#404040"
      />
      <g fill="#404040">
        <path d="M41.6 141l-6.9-.2C14.98 140.15-.64 123.45.03 103.77.7 84 17.36 68.35 37.1 69.02l6.9.2L41.6 141z" />
        <path d="M33 139.76l2.27-70.29c.19-5.35 4.7-9.66 9.98-9.46l1.42.1c5.27.18 9.51 4.77 9.32 10.13l-2.26 70.29c-.19 5.35-4.7 9.66-9.98 9.46l-1.42-.1c-5.37-.18-9.51-4.68-9.32-10.13z" />
      </g>
      <g fill="#404040">
        <path d="M233.4 141l6.9-.2c19.73-.66 35.35-17.36 34.68-37.04-.67-19.77-17.34-35.41-37.08-34.74l-6.9.2 2.4 71.78z" />
        <path d="M242 139.76l-2.37-70.29c-.2-5.35-4.91-9.66-10.42-9.46l-1.47.1c-5.5.18-9.93 4.77-9.73 10.13l2.36 70.29c.2 5.35 4.91 9.66 10.42 9.46l1.47-.1c5.5-.18 9.93-4.68 9.73-10.13z" />
      </g>
      <path
        d="M231 79.3c-2.1 0-4.11-1.35-4.78-3.46-13.32-39.07-49.24-65.34-89.2-65.34-40.04 0-75.86 26.27-89.18 65.34-.86 2.69-3.83 4.04-6.42 3.17-2.68-.86-4.02-3.85-3.16-6.45C52.92 29.36 92.58.3 136.93.3c44.36 0 84.02 29.06 98.77 72.26a4.98 4.98 0 0 1-3.16 6.45c-.48.2-1.05.29-1.53.29zM168.95 204.3c-2.79 0-5.57-.1-8.16-.38-1.63-.1-2.88-1.92-2.78-4.03.1-2.1 1.53-3.73 3.16-3.54 24.67 2.1 43.86-5.37 55.57-21.46 8.83-12.17 10.36-25.1 10.36-25.3.29-2.1 1.73-3.54 3.36-3.25 1.63.28 2.78 2.2 2.5 4.3-.1.58-1.73 15.15-11.71 29.04-14.01 19.64-34.93 24.62-52.3 24.62z"
        fill="#404040"
      />
      <path
        d="M162.16 208.3h-8.32c-4.31 0-7.84-3.38-7.84-7.5 0-4.13 3.53-7.5 7.84-7.5h8.32c4.31 0 7.84 3.38 7.84 7.5 0 4.13-3.53 7.5-7.84 7.5z"
        fill="#404040"
      />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgHeadsetOwl;
